<div class="custom-toggle">
  <app-reactive-dialog-content [data]="dialogInputData">
    <div class="content-container" [formGroup]="formGroup">
      <mat-button-toggle-group formControlName="rejectType" appearance="legacy" aria-label="Select an option">
        @for (option of rejectOptions; track option.value) {
          <mat-button-toggle [value]="option.value">{{ option.label }}</mat-button-toggle>
        }
      </mat-button-toggle-group>
      @if (isChangeSelected) {
        <p>
          Wer soll die Änderung durchführen?
        </p>
        <mat-button-toggle-group formControlName="changeType" appearance="legacy" aria-label="Select an option">
          @for (option of changeOptions; track option.value) {
            <mat-button-toggle [value]="option.value">{{ option.label }}</mat-button-toggle>
          }
        </mat-button-toggle-group>
      } @else {
        <p>
          Das Offert zum abgelehnten Antrag wird Ihnen in Ihrer Offertliste zur Verfügung gestellt.
        </p>
      }
      <!--
      <app-basic-textarea formControlName="reason" label="Nachricht an den Makler"
                          [autosizeMinRows]="8"></app-basic-textarea>
                          -->
    </div>
    <div class="action-button-container">
      <button mat-raised-button color="accent" (click)="onCancelClick()">abbrechen</button>
      <button mat-raised-button color="primary" (click)="confirmSelection()">ok</button>
    </div>
  </app-reactive-dialog-content>
</div>

